import { CHART_HEX_INTERACTIVE, formatDateFrDayMonth } from '@sphere/shared/util'
import { LineChartWrapper } from '../shared'

export interface PersonalEngagementChartProps {
  dailyAttempts: Array<{ date: string; attempts: number }>
}

export function PersonalEngagementChart({
  dailyAttempts,
}: PersonalEngagementChartProps) {
  if (!dailyAttempts || dailyAttempts.length === 0) {
    return null
  }

  return (
    <LineChartWrapper
      data={dailyAttempts}
      dataKey="attempts"
      lines={[
        {
          dataKey: 'attempts',
          name: 'Tentatives',
          stroke: CHART_HEX_INTERACTIVE,
        },
      ]}
      xAxisKey="date"
      title="Tentatives par jour"
      height={300}
      xAxisFormatter={value => formatDateFrDayMonth(value as string)}
    />
  )
}
